/**
 * Canonical Midjourney prompt-parameter contracts.
 *
 * Current ranges and defaults come from Midjourney's official control docs:
 * - Stylize: 0–1000, default 100
 * - Chaos / Variety: 0–100, default 0
 * - Weird: 0–3000, default 0
 *
 * Midjourney documents numeric values rather than coarse presets for these
 * controls. GlowGhost therefore exposes whole-number increments and keeps the
 * exact value editable alongside each slider.
 */

export const MIDJOURNEY_DIALS = Object.freeze({
  stylize: Object.freeze({ min: 0, max: 1000, default: 100, step: 1, switch: '--stylize' }),
  chaos: Object.freeze({ min: 0, max: 100, default: 0, step: 1, switch: '--chaos' }),
  weird: Object.freeze({ min: 0, max: 3000, default: 0, step: 1, switch: '--weird' }),
});

export const MIDJOURNEY_STYLE_WEIGHT = Object.freeze({
  min: 0,
  max: 1000,
  default: 100,
  step: 1,
  switch: '--sw',
});

export const DEFAULT_MIDJOURNEY_VERSION = '8.1';
